import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import clsx from 'clsx'
import Column from './Column'

const braSeedColor = '#7c6b58'
const braBronzeColor = '#c47f5b'
const braSilverColor = '#9d9d9c'
const braGoldColor = '#d9b85f'
const braDiamondColor = '#afc2ce'

const perBronzeColor = '#C47F5B'
const perPureColor = '#3f75d4'
const perSilverColor = '#777067'
const perGoldColor = '#D9B85F'
const perPlatinumColor = '#8B8B8E'
const perSapphireColor = '#6168AB'
const perDiamondColor = '#AFC2CE'

const eloBronzeColor = '#BC5214'
const eloSilverColor = '#9E9794'
const eloGoldColor = '#DDAB00'
const eloPlatinumColor = '#8B8B8E'
const eloSapphireColor = '#B7003C'
const eloDiamondColor = '#8F74E3'

const white = '#ffffff'
const black = '#000000'

const styles = theme => ({
  root: {
    marginTop: '20px',
    '@media (max-width: 319px)': {
      overflowX: 'scroll',
      width: '299px'
    }
  },
  columnText: {
    display: 'flex',
    fontSize: '14px',
    justifyContent: 'center',
    [theme.breakpoints.up('sm')]: { fontSize: '16px' }
  },
  gridItem: {
    [theme.breakpoints.down('sm')]: { maxWidth: '48px' },
    [theme.breakpoints.up('sm')]: { maxWidth: '60px' }
  },
  braSeed: {
    backgroundColor: braSeedColor,
    color: theme.palette.getContrastText(braSeedColor)
  },
  braSeedText: { color: braSeedColor },
  braBronze: {
    backgroundColor: braBronzeColor,
    color: theme.palette.getContrastText(braBronzeColor)
  },
  braBronzeText: { color: braBronzeColor },
  braSilver: { backgroundColor: braSilverColor, color: white },
  braSilverText: { color: braSilverColor },
  braGold: { backgroundColor: braGoldColor, color: white },
  braGoldText: { color: braGoldColor },
  braDiamond: { backgroundColor: braDiamondColor, color: white },
  braDiamondText: { color: braDiamondColor },

  perBronze: {
    backgroundColor: perBronzeColor,
    color: theme.palette.getContrastText(perBronzeColor)
  },
  perBronzeText: { color: perBronzeColor },
  perSilver: { backgroundColor: perSilverColor, color: white },
  perSilverText: { color: perSilverColor },
  perPure: { backgroundColor: perPureColor, color: white },
  perPureText: { color: perPureColor },
  perGold: { backgroundColor: perGoldColor, color: white },
  perGoldText: { color: perGoldColor },
  perDiamond: { backgroundColor: perDiamondColor, color: white },
  perDiamondText: { color: perDiamondColor },
  perPlatinum: { backgroundColor: perPlatinumColor, color: white },
  perPlatinumText: { color: perPlatinumColor },
  perSapphire: { backgroundColor: perSapphireColor, color: white },
  perSapphireText: { color: perSapphireColor },

  eloBronze: {
    backgroundColor: eloBronzeColor,
    color: white
  },
  eloBronzeText: { color: black },
  eloSilver: { backgroundColor: eloSilverColor, color: black },
  eloSilverText: { color: black },
  eloGold: { backgroundColor: eloGoldColor, color: black },
  eloGoldText: { color: black },
  eloDiamond: { backgroundColor: eloDiamondColor, color: black },
  eloDiamondText: { color: black },
  eloPlatinum: { backgroundColor: eloPlatinumColor, color: black },
  eloPlatinumText: { color: black },
  eloSapphire: { backgroundColor: eloSapphireColor, color: white },
  eloSapphireText: { color: black }

})

const PureEarningsChart = ({
  baseAmount,
  baseHeight,
  caption,
  classes,
  className,
  chartLevels,
  currency,
  separator,
  isF2FSales,
  langKey
}) => {
  const values = chartLevels.map(chartLevel => {
    return isF2FSales
      ? chartLevel.node.frontmatter.percentF2F
      : chartLevel.node.frontmatter.percentOnline
  })

  const baseValue = Math.max(...values)

  return (
    <figure className={clsx(className, classes.root)}>
      <Typography component="figcaption" variant="srOnly">
        {caption}
      </Typography>
      <Grid
        container
        alignItems="flex-end"
        component="ul"
        direction="row"
        justify="space-evenly"
        spacing={1}
      >
        {chartLevels.map(chartLevel => {
          const {
            frontmatter: {
              color,
              level,
              percentF2F,
              F2FLabel,
              hideValue,
              onlyShowInOnlineSales,
              percentOnline,
              onlineLabel
            },
            id
          } = chartLevel.node

          // isF2FSales && onlyShowInOnlineSales quer dizer que é um nível que só aparece na tabela de vendas online se a propriedade onlyShowInOnlineSales for true no arquivo de configuração do país
          return isF2FSales && onlyShowInOnlineSales ? null : (<Grid
            item
            key={id}
            className={clsx(classes.gridItem)}
            component="li"
            xs
          >
            <Column
              baseAmount={baseAmount}
              baseHeight={baseHeight}
              baseValue={baseValue}
              className={classes[color]}
              currency={currency}
              hideValue={hideValue}
              separator={separator}
              level={level}
              value={isF2FSales ? percentF2F : percentOnline}
              valueLabel={isF2FSales ? F2FLabel : onlineLabel}
              langKey={langKey}
            />
            <Typography component="span" variant="srOnly">
              {' '}
              para{' '}
            </Typography>
            <Typography
              className={clsx(classes.columnText, classes[`${color}Text`])}
              component="span"
            >
              {level}
            </Typography>
            <Typography component="span" variant="srOnly">
              ;
            </Typography>
          </Grid>)}
            
        )
        }
      </Grid>
    </figure>
  )
}

const EarningsChart = withStyles(styles)(PureEarningsChart)

export default EarningsChart
